import { render, staticRenderFns } from "./AbkEventImageSection.vue?vue&type=template&id=1ab7db98&scoped=true&"
import script from "./AbkEventImageSection.vue?vue&type=script&lang=js&"
export * from "./AbkEventImageSection.vue?vue&type=script&lang=js&"
import style0 from "./AbkEventImageSection.vue?vue&type=style&index=0&id=1ab7db98&lang=scss&scoped=true&"
import style1 from "./AbkEventImageSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab7db98",
  null
  
)

export default component.exports